import * as Types from './types';

const convertPublisher = data => {
  return {
    type: Types.CONVERT_SEEKER_TO_PUBLISHER,
    meta: {
      async: true,
      api: 'publicador',
      path: `/publicador/api/v1/user/convert`,
      method: 'POST',
      body: data
    }
  };
};

const fetchUserCore = () => ({
  type: 'core/userInfo/FETCH_USER_INFO',
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/userInfo',
    method: 'GET'
  }
});

const setMobilePhone = payload => ({
  type: Types.SET_MOBILE_PHONE,
  payload
});

const setTaxConditions = payload => ({
  type: Types.SET_TAX_CONDITIONS,
  payload
});

export { fetchUserCore, convertPublisher, setMobilePhone, setTaxConditions };
